import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "calendar-v3-container" }
const _hoisted_2 = { class: "calendar-page-wrapper" }
const _hoisted_3 = { class: "calendar-wrapper pb-2" }
const _hoisted_4 = {
  key: 0,
  class: "side-bar"
}
const _hoisted_5 = { class: "text-c p-3 hide-mobile" }
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-plus-circle fs-26 browse-icon" }, null, -1)
const _hoisted_7 = { class: "calendar-wrapper pb-2" }
const _hoisted_8 = { class: "hide-mobile m-2" }
const _hoisted_9 = { class: "title w-100 mx-2" }
const _hoisted_10 = { class: "my-2" }
const _hoisted_11 = { class: "d-flex m-2 mx-3 hide-mobile" }
const _hoisted_12 = { class: "w-100 title" }
const _hoisted_13 = { class: "products-filter hide-mobile" }
const _hoisted_14 = { class: "content" }
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-plus fs-16" }, null, -1)
const _hoisted_16 = {
  key: 1,
  class: "d-flex drop-shaddow"
}
const _hoisted_17 = { class: "k-date-wrapper mobile-date pt-2 pb-2 w-100" }
const _hoisted_18 = { class: "k-date-weekday" }
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-calendar fs-16 mx-2" }, null, -1)
const _hoisted_20 = { class: "sheduler-tooltip-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalendarOrderModal = _resolveComponent("CalendarOrderModal")
  const _component_CalendarStopSaleModal = _resolveComponent("CalendarStopSaleModal")
  const _component_CalendarSlotHistoryModal = _resolveComponent("CalendarSlotHistoryModal")
  const _component_CalendarSlotModal = _resolveComponent("CalendarSlotModal")
  const _component_SlotEmployeesModal = _resolveComponent("SlotEmployeesModal")
  const _component_CheckBoxInput = _resolveComponent("CheckBoxInput")
  const _component_OverlayModal = _resolveComponent("OverlayModal")
  const _component_SaveSendNotificationSmsEmailTemplate = _resolveComponent("SaveSendNotificationSmsEmailTemplate")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_CalendarOrderModal, {
      products: _ctx.products,
      ref: "modalOrder",
      onSave: _ctx.reloadSlotAvailability,
      onReloadSlots: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadSlots(true)))
    }, null, 8, ["products", "onSave"]),
    _createVNode(_component_CalendarStopSaleModal, {
      ref: "modalStopSale",
      onStopRemoved: _ctx.onSlotStopRemoved,
      onStopCreated: _ctx.onSlotStopCreated,
      onDeleted: _ctx.onSlotRemoved
    }, null, 8, ["onStopRemoved", "onStopCreated", "onDeleted"]),
    _createVNode(_component_CalendarSlotHistoryModal, {
      ref: "modalHistory",
      onRevert: _ctx.onSlotReverted
    }, null, 8, ["onRevert"]),
    _createVNode(_component_CalendarSlotModal, {
      canMoveOrders: _ctx.canMoveOrders,
      isSoldOut: _ctx.isSoldOut,
      products: _ctx.productsSlotModal,
      ref: "modal",
      onSave: _ctx.onSlotChanged,
      onSaveEvent: _ctx.onEventChanged,
      onSendSmsEmail: _ctx.SendSmsEmail,
      onAddVirtualSlot: _ctx.addVirtualSlot
    }, null, 8, ["canMoveOrders", "isSoldOut", "products", "onSave", "onSaveEvent", "onSendSmsEmail", "onAddVirtualSlot"]),
    _createVNode(_component_SlotEmployeesModal, {
      ref: "modalSlotEmployees",
      onChangeEmployeeIcon: _ctx.changeEmployeeIcon,
      onAssignEmployee: _ctx.assignEmployee,
      onUnassignEmployee: _ctx.unassignEmployee
    }, null, 8, ["onChangeEmployeeIcon", "onAssignEmployee", "onUnassignEmployee"]),
    _createVNode("div", _hoisted_2, [
      _withDirectives(_createVNode("div", _hoisted_3, [
        _createVNode("span", {
          class: ["d-none", { 'k-rtl': _ctx.isRTL }]
        }, null, 2),
        _createVNode("div", {
          ref: "calendarElement",
          class: { 'k-rtl': _ctx.isRTL }
        }, null, 2)
      ], 512), [
        [_vShow, _ctx.isMobileMode && _ctx.showCalendar]
      ]),
      (!_ctx.changeDate)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("button", {
                class: "btn browse-photo browse-button green-button",
                role: "button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onCreateNewSlot && _ctx.onCreateNewSlot(...args)))
              }, [
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('calendar.v3.newslotbtn')), 1)
              ])
            ]),
            _withDirectives(_createVNode("div", _hoisted_7, [
              _createVNode("span", {
                class: ["d-none", { 'k-rtl': _ctx.isRTL }]
              }, null, 2),
              _createVNode("div", {
                ref: "calendarElement",
                class: { 'k-rtl': _ctx.isRTL }
              }, null, 2)
            ], 512), [
              [_vShow, !_ctx.isMobileMode || _ctx.showCalendar]
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('calendar.v3.events_title')), 1),
              _createVNode("div", _hoisted_10, [
                _createVNode(_component_CheckBoxInput, {
                  modelValue: _ctx.showEvents,
                  "onUpdate:modelValue": [
                    _cache[3] || (_cache[3] = ($event: any) => (_ctx.showEvents = $event)),
                    _cache[4] || (_cache[4] = ($event: any) => (_ctx.onFilter()))
                  ],
                  singleLine: true
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('calendar.events.show-events')), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('calendar.v3.filter_product.title')), 1),
              (_ctx.products.length != _ctx.selectedProducts.length)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    class: "k-button text-nowrap",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onFilter(true)))
                  }, _toDisplayString(_ctx.$t('calendar.v3.filter_product.showall')), 1))
                : (_openBlock(), _createBlock("button", {
                    key: 1,
                    class: "k-button text-nowrap",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onFilter(false)))
                  }, _toDisplayString(_ctx.$t('calendar.v3.filter_product.hideall')), 1))
            ]),
            _createVNode("div", _hoisted_13, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.products, (p) => {
                return (_openBlock(), _createBlock(_component_CheckBoxInput, {
                  key: p.id,
                  value: p.id,
                  modelValue: _ctx.selectedProducts,
                  "onUpdate:modelValue": [
                    _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectedProducts = $event)),
                    _ctx.onFilter
                  ],
                  singleLine: true
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(p.name) + " ", 1),
                    _createVNode("div", {
                      class: "rounded-circle product-color d-inline-flex",
                      style: { 'background-color': p.color }
                    }, null, 4)
                  ]),
                  _: 2
                }, 1032, ["value", "modelValue", "onUpdate:modelValue"]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_14, [
        (!_ctx.changeDate)
          ? (_openBlock(), _createBlock("button", {
              key: 0,
              class: "float-button add-slot-mobile",
              type: "button",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onCreateNewSlot && _ctx.onCreateNewSlot(...args)))
            }, [
              _hoisted_15
            ]))
          : _createCommentVNode("", true),
        (_ctx.isMobileMode)
          ? (_openBlock(), _createBlock("div", _hoisted_16, [
              _createVNode("i", {
                class: "icon-f icon-calendar-arrow-back px-3 arrows",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.navigateDate(-1)))
              }),
              _createVNode("div", _hoisted_17, [
                _createVNode("div", _hoisted_18, _toDisplayString(_ctx.selectedDateData.day), 1),
                _createVNode("div", {
                  class: "k-date-day mb-1",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showCalendar = true))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.selectedDateData.date) + " ", 1),
                  _hoisted_19
                ])
              ]),
              _createVNode("i", {
                class: "icon-f icon-calendar-arrow-next px-3 arrows",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.navigateDate(1)))
              })
            ]))
          : _createCommentVNode("", true),
        _createVNode("span", {
          class: ["d-none", { 'k-rtl': _ctx.isRTL }]
        }, null, 2),
        _createVNode("div", {
          ref: "kendoWrapper",
          class: { 'k-rtl': _ctx.isRTL }
        }, null, 2)
      ])
    ]),
    _createVNode(_component_OverlayModal, {
      isOpen: _ctx.tooltipSlotInfo.visible,
      "onUpdate:isOpen": _cache[13] || (_cache[13] = ($event: any) => (_ctx.tooltipSlotInfo.visible = $event)),
      modalWidth: 260
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_20, [
          _createVNode("div", null, _toDisplayString(_ctx.tooltipSlotInfo.product), 1),
          _createVNode("div", null, _toDisplayString(_ctx.tooltipSlotInfo.startTime) + " - " + _toDisplayString(_ctx.tooltipSlotInfo.endTime), 1),
          _createVNode("i", {
            class: "icon-f icon-delete-cross fs-10 pull-end",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.tooltipSlotInfo.visible = false))
          })
        ]),
        _createVNode("div", {
          innerHTML: _ctx.tooltipSlotInfo.content,
          class: "sheduler-tooltip mobile pb-3"
        }, null, 8, ["innerHTML"])
      ]),
      _: 1
    }, 8, ["isOpen"]),
    _createVNode(_component_SaveSendNotificationSmsEmailTemplate, {
      ref: "modalSaveSendNotificationSmsEmailTemplate",
      onEmitTemplate: _ctx.SendSmsEmail,
      keys: _ctx.messageTemplateKeysForOrders
    }, null, 8, ["onEmitTemplate", "keys"])
  ]))
}